import React from "react";
import "./../css/users.css";
import Logo from "../assets/images/01hire-logo.svg";
import FatDude from "../assets/images/fat-dude.svg";

function LeftSideNav() {
  return (
    <>
      <div className="l-c">
        <div className="l-c-logo">
          <img src={Logo} alt="01hire-logo" />
        </div>
        <div className="l-c__new-img-text">
          <img src={FatDude} alt="using-01hire" />
        </div>
      </div>
    </>
  );
}

export default LeftSideNav;
